module.exports = __webpack_public_path__ + "img/document.dd61f612.png";